import {
    PRICE_POLICIES_GET_ROLE_BONIFICATION_BEGIN,
    PRICE_POLICIES_GET_ROLE_BONIFICATION_SUCCESS,
    PRICE_POLICIES_GET_ROLE_BONIFICATION_FAILURE
} from '../constants'

export function reducer(state, action) {
    switch (action.type) {
        case PRICE_POLICIES_GET_ROLE_BONIFICATION_BEGIN:
            return {
                ...state,
                userRolesError: false
            }
        case PRICE_POLICIES_GET_ROLE_BONIFICATION_SUCCESS:
            return {
                ...state,
                userRolesPending: false,
                userRolesError: false,
                roleBonification: action.data.roleBonification
            }
        case PRICE_POLICIES_GET_ROLE_BONIFICATION_FAILURE:
            return {
                ...state,
                userRolesPending: false,
                userRolesError: action.data.userRolesError
            }
        default:
            return state
    }
}
